import { render, staticRenderFns } from "./CostCalc.vue?vue&type=template&id=63fe4369&scoped=true"
import script from "./CostCalc.vue?vue&type=script&lang=js"
export * from "./CostCalc.vue?vue&type=script&lang=js"
import style0 from "./CostCalc.vue?vue&type=style&index=0&id=63fe4369&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fe4369",
  null
  
)

export default component.exports